import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { LassiProfiles } from '@lassi/webapp-shared';

@Component({
  selector: 'lib-layer-preset-card',
  imports: [MatCardModule, MatIconModule],
  template: `
    <mat-card class="option-card" (click)="onCardClicked()" role="button">
      <mat-card-content class="grid">
        <div
          class="icon"
          [style.background-color]="iconBackgroundColor()"
          aria-hidden="true"
        >
          <mat-icon>
            {{ iconName() }}
          </mat-icon>
        </div>
        <div class="text">
          <div class="title-row">
            <h3 class="mat-title-medium title">
              {{ displayName() }}
            </h3>
          </div>
          <p class="mat-body-large description">{{ presetDescription() }}</p>
        </div>
      </mat-card-content>
    </mat-card>
  `,
  styles: [
    `
      @use 'breakpoints' as *;

      .option-card {
        box-shadow: none;
        transition: background-color 0.3s ease;
        padding: 0;
        cursor: pointer;

        &:hover {
          background-color: #e0f0ff;
        }

        .grid {
          display: grid;
          grid-template-columns: auto 1fr auto;
          grid-template-areas: 'icon text arrow';
          align-items: center;
          gap: 12px;
        }

        .icon {
          grid-area: icon;
          font-size: 24px;
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
        }

        .text {
          grid-area: text;
          align-self: start;
          display: flex;
          flex-direction: column;
          gap: 4px;
          justify-content: flex-start;
        }

        .title {
          font-size: 15px;
          font-weight: 600;
          display: inline-block;
          margin: 0;

          @include tablet {
            font-size: 16px;
          }
        }

        .description {
          font-size: 12px;
          font-weight: 450;
          display: inline-block;
          margin: inherit;
          line-height: inherit;

          @include tablet {
            font-size: 16px;
          }
        }

        .title-row {
          display: flex;
          justify-content: space-between;
          gap: 8px;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayerPresetCardComponent {
  profile = input<LassiProfiles>('Custom');
  displayName = input<string>('Custom');
  presetDescription = input<string | undefined>('Layer Preset Description');
  iconBackgroundColor = input<string | undefined>('white');
  iconName = input<string | undefined>('check');
  profileClicked = output<LassiProfiles>();

  onCardClicked() {
    this.profileClicked.emit(this.profile());
  }
}
